// extracted by mini-css-extract-plugin
export default {"bio":"Bio_bio__Wcuob","programmer":"Bio_programmer__Vk9UN","musician":"Bio_musician__TW2rZ","profile":"Bio_profile__yA630","text_column":"Bio_text_column__uf6cV"};